// extracted by mini-css-extract-plugin
export const card = "styles-module--card--7Y-b7";
export const btn = "styles-module--btn--Nlpuz";
export const btnGet = "styles-module--btnGet--J4ASr";
export const txtTitle = "styles-module--txtTitle--N7BiL";
export const txtDes = "styles-module--txtDes---L4bL";
export const txtHelper = "styles-module--txtHelper--xKNIN";